import { axiosInstance, handleApiRequest } from './apiClient';
import { FeedbackRequest } from 'types/feedback';


export interface FeedbackResponse {
  id: string;
  message: string;
  timestamp: string;
}

const feedbackAPI = {
  submitFeedback: async (sessionId: string, feedbackData: FeedbackRequest, chatMode: string = 'bot') => {
    return handleApiRequest<FeedbackResponse>(
      axiosInstance.put(`/sessions/${sessionId}/feedback?chat_mode=${chatMode}`, feedbackData),
    );
  },
};

export default feedbackAPI;
